export const PRIMARY_COLOR = '#053605';